/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberDocumentPagedResponseDto { 
    id?: number;
    fileData?: string | null;
    fileType?: string | null;
    documentTypeId?: number;
    creationTime?: string;
    userId?: number;
    documentFileName?: string | null;
    memberDocumentType?: string | null;
    comment?: string | null;
    documentId?: string;
}

